import { render, staticRenderFns } from "./ForgetHit.vue?vue&type=template&id=2cb4499c&scoped=true"
import script from "./ForgetHit.vue?vue&type=script&lang=js"
export * from "./ForgetHit.vue?vue&type=script&lang=js"
import style0 from "./ForgetHit.vue?vue&type=style&index=0&id=2cb4499c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb4499c",
  null
  
)

export default component.exports